import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_8c83495a/components/surfslot-landing.tsx");
